/**
 * @generated SignedSource<<dd0b9cd43ddcd92832279d7f361f6ea2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type AIGenerationMessageKind = "input" | "output" | "%future added value";
export type ContentType = "assignment" | "assignment_submission" | "attachment" | "comment" | "confirmation" | "custom" | "embed" | "module" | "occurrence" | "post" | "quiz" | "survey" | "text" | "video" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type AICanvasDrawerMessageFragment$data = {
  readonly id: string;
  readonly input: {
    readonly prompt: string | null;
    readonly searchWeb: boolean | null;
  } | null;
  readonly kind: AIGenerationMessageKind;
  readonly output: {
    readonly curriculumModules: ReadonlyArray<{
      readonly content: ReadonlyArray<{
        readonly summary: string;
        readonly title: string;
        readonly type: ContentType;
      }>;
      readonly title: string;
    }> | null;
    readonly responseMessage: string | null;
    readonly searchResults: ReadonlyArray<{
      readonly moduleTitle: string | null;
      readonly query: string;
      readonly urls: ReadonlyArray<string>;
    }> | null;
  } | null;
  readonly " $fragmentType": "AICanvasDrawerMessageFragment";
};
export type AICanvasDrawerMessageFragment$key = {
  readonly " $data"?: AICanvasDrawerMessageFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"AICanvasDrawerMessageFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AICanvasDrawerMessageFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "kind",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AIGenerationMessageOutput",
      "kind": "LinkedField",
      "name": "output",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "responseMessage",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "AIGenerationSearchResult",
          "kind": "LinkedField",
          "name": "searchResults",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "moduleTitle",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "query",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "urls",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "AIGenerationCurriculumModule",
          "kind": "LinkedField",
          "name": "curriculumModules",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "AIGenerationCurriculumContent",
              "kind": "LinkedField",
              "name": "content",
              "plural": true,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "type",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "summary",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AIGenerationMessageInput",
      "kind": "LinkedField",
      "name": "input",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "prompt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "searchWeb",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "AIGenerationMessage",
  "abstractKey": null
};
})();

(node as any).hash = "86391010208c134233b9191e3c7ba42b";

export default node;
